import React from 'react';
import DataContainer from 'Components/UI/DataContainer';
import Content from './Content';
import { useBalanceTransferRolloverContext } from './Context';

const BalanceTransferRollover = (props) => {
  const { balTranCollection, initializingError, isInitializing } = useBalanceTransferRolloverContext();

  return (
    <DataContainer
      component={Content}
      componentProps={{
        collection: balTranCollection,
      }}
      loading={isInitializing}
      loadingError={initializingError}
      {...props}
    />
  );
};

export default BalanceTransferRollover;
